export default __webpack_public_path__ + "static/media/fridge1-after2-1440w.61b8dd6d.png";